<template>
  <div style="font-size: 12px;">系统已登录成功，正在跳转，请稍等...</div>
</template>
<script>
export default {
  name: "wxLoginSucce",
  data() {
    return {};
  },
  created() {
    let params = {
      fid: this.$route.query.openFid
    };
    this.$store.dispatch("user/loginWx", params).then(result => {
      if (result.returnCode == 0) {
        window.localStorage.setItem("hodiToken", result.data.token);
        this.$store.dispatch("user/setToken", result.data.token);
        window.localStorage.setItem("loginType", "wechat");
        this.$router.push({ path: "/property" });
        this.load.$emit("loading", false);
      } else {
        this.load.$emit("loading", false);
        this.$confirm({
          mesg: result.returnMsg,
          cancel: false,
          btn: {
            confirmVal: "确 定"
          }
        });
      }
    });
  },
  methods: {
    toPropPage(result) {
      if (!window.location.origin || window.location.origin == undefined) {
        window.location.origin =
          window.location.protocol +
          "//" +
          window.location.hostname +
          (window.location.port ? ":" + window.location.port : "");
      }
      let redirecter = window.location.origin + "/#/property";

      if (result.data.needWechatAuthorization) {
        let url;
        if (window.localStorage.getItem("prop")) {
          url =
            result.data.wechatAuthorizationUrl +
            "&prop=" +
            window.localStorage.getItem("prop") +
            "&redirect=" +
            encodeURIComponent(redirecter);
        } else {
          url =
            result.data.wechatAuthorizationUrl +
            "&redirect=" +
            encodeURIComponent(redirecter);
        }
        // alert('aaa=='+url)
        // alert(result.data.wechatAuthorizationUrl)
        window.location.href = url; //decodeURIComponent
      } else {
        // alert('bbb=='+redirecter)
        window.location.href = redirecter;
        window.location.reload();
      }
    }
  }
};
</script>
<style scoped lang="less"></style>
